// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import batchMaintenance from './metaData/batchMaintenanceForm.js'
export default {
  state: batchMaintenance,
  actions
}
